import CategoryForm from '../../components/Forms/CategoryForm';
import { invalidUrlError, validateUrl } from '../../utils/functions';

const FundingForm = ({ functionality }) => {
  const category = 'grant';
  const fields = [
    {
      name: 'grant_types',
      label: 'Category',
      type: 'text',
      required: true,
      placeholder: 'Governmental, Corporate, VC, Philanthropic, Other',
    },
    {
      name: 'AgencyName',
      label: 'Name of Funding Source Organization',
      type: 'text',
      required: true,
    },
    {
      name: 'grant_source_url',
      label: 'Grant URL',
      type: 'text',
      placeholder: 'https://grants.gov/search-results-detail/355599',
      pattern: validateUrl,
      title: invalidUrlError,
      required: true,
    },
    { name: 'OpportunityTitle', label: 'Title', type: 'text', required: true },
    { name: 'CFDANumbers', label: 'CFDA Numbers', type: 'text' },
    {
      name: 'EligibleApplicants',
      label: 'Eligibility Criteria',
      type: 'text',
      text_area: true,
      placeholder: 'Career stage, Nationality requirements, etc.',
    },
    {
      name: 'Description',
      label: 'Description',
      type: 'text',
      text_area: true,
      rows: '12',
      required: true,
    },
    { name: 'AwardCeiling', label: 'Award Ceiling', type: 'text', placeholder: '$100,000' },
    { name: 'AwardFloor', label: 'Award Floor', type: 'text', placeholder: '$100,000' },
    { name: 'ExpectedNumberOfAwards', label: 'Expected Number Of Awards', type: 'number' },
    {
      name: 'EstimatedTotalProgramFunding',
      label: 'Estimated Total Program Funding',
      type: 'text',
      placeholder: '$100,000',
    },
    { name: 'PostDate', label: 'Post Date', type: 'date' },
    { name: 'CloseDate', label: 'Application Deadline', type: 'date' },
    { name: 'EstimatedAwardDate', label: 'Estimated Award Date', type: 'date' },
    { name: 'GrantorContactName', label: 'Grantor Contact Name', type: 'text' },
    { name: 'GrantorContactEmail', label: 'Grantor Contact Email', type: 'email' },
    { name: 'GrantorContactPhoneNumber', label: 'Grantor Contact Phone Number', type: 'text' },
    { name: 'GrantorContactText', label: 'Grantor Contact Text', type: 'text', text_area: true },
    { name: 'EstimatedProjectStartDate', label: 'Estimated Project Start Date', type: 'date' },
    {
      name: 'AdditionalInformationURL',
      label: 'Additional Information Url',
      type: 'text',
      placeholder: 'https://cieif.org/guidelines-for-grant-applicants/',
      pattern: validateUrl,
      title: invalidUrlError,
    },
    {
      name: 'AdditionalInformationOnEligibility',
      label: 'Additional Information On Eligibility',
      type: 'text',
      text_area: true,
      rows: '12',
    },
    {
      name: 'submission_info',
      label: 'Submission Information',
      type: 'text',
      text_area: true,
      rows: '12',
    },
    {
      name: 'support_info',
      label: 'Support Information',
      type: 'text',
      text_area: true,
      rows: '12',
    },
    {
      name: 'additional_info',
      label: 'Additional Notes or Restrictions',
      type: 'text',
      text_area: true,
      rows: '12',
    },
    { name: 'image_url', label: 'Funding Source Logo', type: 'image' },
  ];

  return <CategoryForm functionality={functionality} category={category} fields={fields} />;
};
export default FundingForm;
